<template>
  <footer id="sticky-footer" class="py-2 bg-dark text-white-50">
    <div class="container text-center">
      <small>Copyright &copy; Your Website</small>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "AppFooter"
  };
</script>


<style>
  #sticky-footer {
    flex-shrink: none;
    height: 40px;  
    left: 0;   
    bottom: 0;
    width: 100%;
  }
</style>